import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Flex, Text } from '@indeed/ifl-components';
import { useAutoApplyFlow } from '../../lib/pageFlow/flows/useAutoApplyFlow';
import GettextFactory from '../../util/GettextFactory';

/**
 * AutoApplyNavigation Component
 * Displays the top navigation bar for auto-apply flow with:
 * - Step counter (e.g. "2 of 5") derived from useAutoApplyFlow
 * - Close button
 *
 * No props needed — current step and total are computed from the flow hook.
 */
export const AutoApplyNavigation: React.FC = () => {
    const gt = GettextFactory();
    const { draftId } = useParams<{ draftId: string }>();
    const { draftIds } = useAutoApplyFlow(true);

    const totalSteps = draftIds.length;
    const currentStep = draftId ? draftIds.indexOf(draftId) + 1 : 0;

    return (
        <Box
            sx={{
                backgroundColor: 'color.background.surface',
                inlineSize: '100%',
            }}
        >
            {/* Navigation Container */}
            <Box
                sx={{
                    margin: '0',
                    inlineSize: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '16px',
                    padding: '16px 0',
                }}
            >
                {/* Top Row: Step Counter and Close */}
                <Flex
                    sx={{
                        alignItems: 'center',
                        justifyContent: 'center',
                        position: 'relative',
                    }}
                >
                    {/* Center: Step Counter (hidden when no draftId, e.g. confirmation/success) */}
                    {draftId && totalSteps > 0 && (
                        <Text level={2} sx={{ color: 'color.text.primary' }}>
                            {gt.gettext('{0} of {1}', [currentStep, totalSteps])}
                        </Text>
                    )}
                </Flex>
            </Box>
        </Box>
    );
};

export default AutoApplyNavigation;
